import { formatTermsDate } from "./termsFormat";

/** Safe for a download filename: letters, digits, dots, hyphens, underscores. */
const sanitizeFilenamePart = (value: string): string =>
	value
		.trim()
		.replace(/\s+/g, "-")
		.replace(/[^a-zA-Z0-9._-]/g, "")
		.replace(/-+/g, "-")
		.replace(/^-|-$/g, "") || "terms";

/**
 * Builds the download name from the same version + effective date shown in the
 * modal header. Example: `Supplier-Terms-and-Conditions_v1.1_effective_22-September-2026.pdf`
 */
export const buildTermsPdfFilename = (
	title: string,
	version: string,
	effectiveDate?: string
): string => {
	const titlePart = sanitizeFilenamePart(title);
	const versionPart = sanitizeFilenamePart(version);
	const dateLabel = effectiveDate ? formatTermsDate(effectiveDate) : "";
	const datePart = dateLabel ? `_effective_${sanitizeFilenamePart(dateLabel)}` : "";

	return `${titlePart}_v${versionPart}${datePart}.pdf`;
};
